export const SEARCH_DOCTORS_REQUEST = 'SEARCH_DOCTORS_REQUEST';
export const SEARCH_DOCTORS_SUCCESS = 'SEARCH_DOCTORS_SUCCESS';
export const SEARCH_DOCTORS_FAILURE = 'SEARCH_DOCTORS_FAILURE';